var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enterprise"},[_c('div',{staticClass:"left"},[_c('c-menu',{attrs:{"list":_vm.menuList}})],1),_c('div',{staticClass:"right"},[_c('keep-alive',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }